export const scrollToQuoteForm = () => {
  document.getElementById('quote-form')?.scrollIntoView({ behavior: 'smooth' });
};

export const navigateToQuoteForm = (
  history: { push: (path: string) => void },
  location: { pathname: string }
) => {
  if (location.pathname === '/') {
    scrollToQuoteForm();
  } else {
    history.push('/#quote-form');
  }
};
